var Component = require("../../model/Component");

Component.registerSubTypeDefaulter('timeline', function () {
  // Only slider now.
  return 'slider';
});


//////////////////
// WEBPACK FOOTER
// ../src/~/echarts/lib/component/timeline/typeDefaulter.js
// module id = 1542
// module chunks = 0